import React from "react";
import styled from "styled-components";
import {SlArrowUp} from "react-icons/sl";
import { Link } from "react-router-dom";

export default function Footer() {

    // const handleScrollUp = () => {
    //     window.scrollTo({ top: 0, behavior: "smooth" });
    // }

return(
    <Container>
        <div className="content">
            <div className="left flex a-center">
                <h5>SolarAIDD</h5>
                <h5> Contact us: solaraiddsupport@csir.co.za </h5>
            </div> 
            {/* <div className="center flex" onClick={() => handleScrollUp()} >
                <SlArrowUp />
                <h4> Top </h4>
            </div> */}
            <div className="left flex a-center">
                <h5>
                  <Link to={"/about"}> More information. </Link>
                </h5>
            </div>
        </div>
    </Container>
)
}

const Container = styled.div`
position: relative
height: 6.5rem;
width: 100%;
.content {
    height: 6.5rem;
    background-color: #2A3439;
    color: white;    
    display: flex;
    flex-direction: row; 
    justify-content: space-between;    
    padding: 0 6rem;   
    align-items: center;
    text-align: center; 
    .left {        
        display: flex;
        flex-direction: column; 
        h5 {
            a {
              color: white;
              text-decoration: underline;
            }          
        }
    }
    .center {
        display: flex;
        flex-direction: column; 
        justify-content: space-between;
        :hover {
            cursor: pointer;
        }
        svg {
            font-size: 3rem;
            color: #E55B41;
        }
    }
    .right {
        gap: 1rem;
        li {
            a {
              color: white;
              text-decoration: underline;
            }          
        }
    }
}
`;